export default function SearchSerializer(options) {
  this.arrayKeys = (options && options.arrayKeys) || {};

  this.readFromHash = function() {
    var hash = window.location.hash.replace(/^#\??/, '');
    var params = {};
    if (!hash) return params;

    hash.split('&').forEach(function(pair) {
      var parts = pair.split('=');
      var key = decodeURIComponent(parts[0]);
      var val = decodeURIComponent(parts[1] || '');
      if (params[key] !== undefined) {
        if (!Array.isArray(params[key])) params[key] = [params[key]];
        params[key].push(val);
      } else {
        params[key] = val;
      }
    });
    return params;
  };

  this.deserialize = function(rawParams, defaults) {
    var result = {};
    var self = this;
    Object.keys(rawParams).forEach(function(key) {
      result[key] = rawParams[key];
    });

    Object.keys(this.arrayKeys).forEach(function(key) {
      var valueType = self.arrayKeys[key];
      var val = rawParams[key];

      if (val === 'all' && defaults[key]) {
        result[key] = defaults[key].slice();
      } else if (val === 'none') {
        result[key] = [];
      } else if (Array.isArray(val)) {
        result[key] = val
          .map(function(x) { return valueType === Number ? parseInt(x, 10) : x.toString(); })
          .filter(function(x) { return valueType !== Number || !isNaN(x); });
      } else if (val !== undefined && val !== null && val !== '') {
        var coerced = valueType === Number ? parseInt(val, 10) : val.toString();
        result[key] = (valueType === Number && isNaN(coerced)) ? [] : [coerced];
      }
    });

    return result;
  };

  this.serialize = function(search, defaults) {
    var result = {};
    var self = this;
    Object.keys(search).forEach(function(key) { result[key] = search[key]; });

    Object.keys(this.arrayKeys).forEach(function(key) {
      if (!Array.isArray(result[key])) return;
      if (defaults[key] && result[key].length === defaults[key].length && defaults[key].length > 0) {
        result[key] = 'all';
      } else if (result[key].length === 0) {
        result[key] = 'none';
      }
    });

    return result;
  };

  this.writeToHash = function(search) {
    var parts = [];
    Object.keys(search).forEach(function(key) {
      var val = search[key];
      if (val === null || val === undefined || val === '') return;
      if (typeof val === 'number' && isNaN(val)) return;
      if (Array.isArray(val)) {
        val.forEach(function(v) {
          if (typeof v === 'number' && isNaN(v)) return;
          parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(v));
        });
      } else {
        parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(val));
      }
    });
    window.location.hash = '?' + parts.join('&');
  };
}
